<template>
  <pu-link
    :path="getFavouritesLink()"
    class="favourites-link"
    :class="{ 'router-link-active': isFavouritesPage }"
    :aria-label="$t('Favourites')"
  >
    <lazy-app-header-favourites-count />
    <svg
      v-once
      id="favourites-icon"
      width="100%"
      height="100%"
      viewBox="0 0 25 19"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xml:space="preserve"
      :title="$t('Favourites')"
      style="
        fill-rule: evenodd;
        clip-rule: evenodd;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-miterlimit: 1.41421;
      "
    >
      <path
        d="M9.861,3.537c0.937,-1.416 2.238,-2.694 4.528,-2.513c2.345,0.185 4.183,2.247 4.353,4.677c0.147,2.106 -0.621,3.429 -1.579,4.484c-1.911,2.104 -3.904,4.143 -5.968,6.224c-0.357,0.36 -0.837,1.112 -1.299,1.121c-0.36,0.007 -0.755,-0.484 -1.123,-0.889c-1.616,-1.78 -3.229,-3.418 -4.914,-5.103c-0.626,-0.625 -1.422,-1.405 -1.896,-2.087c-0.611,-0.879 -1.052,-2.075 -0.948,-3.672c0.162,-2.483 2.013,-4.551 4.283,-4.755c2.357,-0.212 3.601,1.021 4.563,2.513"
      /></svg
    ><translate class="sr-only"> Favourites </translate>
  </pu-link>
</template>

<script setup lang="ts">
import { getUrlPrefix } from '~/lang/locales'

const getFavouritesLink = () => {
  const locale = useI18n().i18n.locale
  return `${getUrlPrefix(locale)}/favourites/`
}

const isFavouritesPage = computed(() => {
  const route = useRoute()
  return route.path.includes('/favourites/')
})
</script>
<style scoped>
#favourites-icon {
  fill: none;
  stroke: var(--colour-light-green);
  stroke-width: 1.8;
}
</style>
